import styledComponents from 'styled-components';
export const styled = (styledComponents.styled ||
    styledComponents.default ||
    styledComponents);
